import React from "react";
import { Card, Typography, Button, Space } from "antd";
import { ArrowRightOutlined, WarningOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import PrimaryButton from "../Buttons/PrimaryButton";

const { Title, Paragraph, Text } = Typography;

const WelcomeCard = ({ userData, seoFixCount }) => {
	return (
		<Card
			className="welcome-card"
			style={{
				borderRadius: "12px",
				boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
			}}
		>
			<Title level={3} style={{ marginBottom: 8 }}>
				👋 Welcome, {userData?.firstName} {userData?.lastName}
			</Title>
			<Paragraph style={{ color: "#555" }}>
				Manage your AI-powered product descriptions with ease.
			</Paragraph>

			{seoFixCount > 0 && (
				<Space
					style={{
						display: "flex",
						alignItems: "center",
						background: "#FFF4E5",
						padding: "10px",
						borderRadius: "8px",
						marginBottom: 16,
					}}
				>
					<WarningOutlined style={{ color: "#FAAD14" }} />
					<Text strong style={{ color: "#D46B08" }}>
						{seoFixCount} product{seoFixCount > 1 ? "s" : ""} need SEO fixes.
					</Text>
					<Link to="/seo-fixes">
						<Button type="link" size="small">
							Fix Now
						</Button>
					</Link>
				</Space>
			)}

			<Link to={"/products"}>
				<PrimaryButton icon={<ArrowRightOutlined />}>
					Go to Products
				</PrimaryButton>
			</Link>
		</Card>
	);
};

export default WelcomeCard;
